































import mixins from 'vue-typed-mixins';
import { Section, Survey } from '@/utils/SurveyUtils';
import SurveyLayoutPage from './SurveyLayoutPage.vue';
import PageForm from '@/components/survey/management/PageForm.vue';
import SectionForm from '@/components/survey/management/SectionForm.vue';
import LayoutUtils from './LayoutUtils';
export default mixins().extend({
  name: 'SurveyLayoutSection', // name needed for recursive reference
  components: {
    SurveyLayoutPage,
    PageForm,
    SectionForm,
  },
  props: {
    value: {
      type: Object as () => Section,
    },
    layout: {
      type: Array as () => Survey['layout'],
    },
  },
  methods: {
    validateMove(evt: any) {
      return LayoutUtils.validateMove(evt);
    },

    create(parent: any) {
      this.$emit('create', parent);
    },

    edit(item: any) {
      this.$emit('edit', item);
    },

    remove(item: any) {
      this.$emit('remove', item);
    },
  },
});
